<template>
  <div>
    <router-view v-if="showIndex"></router-view>
    <div class="full-height box" :class="{ 'has-owner-upsell-footer': isOwnFreeLink }" v-else>
      <div class="verticle-center" v-if="loading" key="0001">
        <v-container class="horizontaly-center">
          <div key="1" class="redirect-avatar-wrap">
            <v-avatar width="120" height="120" class="redirect-avatar">
              <v-img v-if="config && config.picture && config.picture.src && !config.picture.deleted" :src="config.picture.src" key="1" width="120" height="120"/>
              <v-img v-else src="/images/logo/logo-04.png" contain key="2" width="120" class="pointer" @click="$router.push('/')"/>
            </v-avatar>
          </div>
          <v-fade-transition leave-absolute hide-on-leave>
            <div class="redirect-sitename" v-if="config">
              {{config.siteName}}
            </div>
          </v-fade-transition>
          <v-fade-transition leave-absolute hide-on-leave>
            <div class="redirect-progress-row" v-if="!(isFreePlanLink && continueGateEnabled)">
              <v-progress-circular :indeterminate="!config && !isCancel" :value="progress" width="2" size="26" :color="isCancel ? 'transparent' : `primary`">
              </v-progress-circular>
            </div>
          </v-fade-transition>
          <v-container class="redirect-body">
            <v-card v-if="address && address.url" flat class="redirect-destination-card card-corner-radius" style="line-break:anywhere">
              <div class="redirect-destination-label">{{ $t('youWillBeRedirectedTo') }}</div>
              <div class="redirect-destination-url">{{ address.url }}</div>
              <v-divider class="my-3"/>
              <!-- Free-plan countdown finished: the same slot that showed "Cancelar
                   direcionamento" switches to "Continuar" instead of a separate button
                   elsewhere on the screen. (Comment deliberately kept outside the
                   v-if/v-else-if/v-else chain below - a comment node between those
                   siblings breaks Vue's else-if adjacency check.) -->
              <v-slide-y-transition>
                <div v-if="isCancel" class="redirect-actions-row" key="report-action">
                  <v-btn outlined color="primary" class="redirect-report-btn rounded-lg text-none" @click="reportData.dialog = true">
                    <v-icon left>mdi-flag-outline</v-icon>
                    {{ $t('reportLink') }}
                  </v-btn>
                </div>
                <div v-else-if="isFreePlanLink && continueGateEnabled" class="redirect-actions-row" key="continue-action">
                  <v-btn rounded color="primary" elevation="0" class="redirect-continue-btn text-none" @click="activateContinueGate">
                    {{ $t('continueToDestination') }}
                    <v-icon right size="18">mdi-arrow-right</v-icon>
                  </v-btn>
                </div>
                <div v-else class="redirect-actions-row" key="cancel-trigger">
                  <div class="redirect-cancel-trigger" @click="isCancel = true">
                    <span class="redirect-cancel-label">{{ $t('cencelRedirected') }}</span>
                    <v-progress-linear :value="progress" height="3" color="primary" rounded/>
                  </div>
                </div>
              </v-slide-y-transition>
            </v-card>
            <div v-if="isFreePlanLink" class="redirect-fallback-row">
              <a href="/" target="_blank">
                <v-btn rounded class="redirect-fallback-cta text-none" elevation="0">
                  <img src="/images/logo/logo-02.png" width="20" height="20" class="mr-2"/>
                  {{ $t('shortenWithMigly') }}
                </v-btn>
              </a>
            </div>
          </v-container>
          <v-app-bar absolute extended color="transparent" v-if="isFreePlanLink" elevation="0">
            <template v-slot:extension>
              <v-container>
                <SponsoredAdBanner @impression="onSponsoredAdImpression"/>
              </v-container>
            </template>
          </v-app-bar>
          <v-app-bar absolute extended color="transparent" elevation="0" v-else-if="interstitial && interstitial.bannerImage && interstitial.bannerImage.src">
            <template v-slot:extension>
              <v-container>
                <InterstitialBannerPreview :interstitial="interstitial" :entrance-delay="0.24"/>
              </v-container>
            </template>
          </v-app-bar>
        </v-container>
        <div v-if="isOwnFreeLink" class="redirect-owner-upsell">
          <v-container class="redirect-owner-upsell-inner">
            <v-icon size="16" color="primary" class="redirect-owner-upsell-icon">mdi-crown-outline</v-icon>
            <span class="redirect-owner-upsell-text">{{ $t('redirectOwnerUpsellText') }}</span>
            <a href="/painel/plans" class="redirect-owner-upsell-cta-link">
              <v-btn rounded color="primary" elevation="0" class="redirect-owner-upsell-cta text-none">
                {{ $t('upgradeToPlus') }}
                <v-icon right size="16">mdi-arrow-right</v-icon>
              </v-btn>
            </a>
          </v-container>
        </div>
      </div>
      <div v-else-if="biography" key="0002" class="full-height">
        <v-container class="bio-page-container" :style="`height: 100%; ${['xs' , 'sm'].includes($vuetify.breakpoint.name) ? 'padding: 0px' : ''}`">
          <v-card width="100%" elevation="0" height="100%">
            <BiographySmartphoneView  :bio="biography" :onlySmartphone="false"/>
          </v-card>
        </v-container>
      </div>
      <div v-else-if="infoproduct" key="0002" class="infoproduct-page-wrap">
        <v-container class="infoproduct-page-container">
          <InfoproductView :infoproduct="infoproduct" :edit="false" :view="$vuetify.breakpoint.name"/>
        </v-container>
      </div>
      <div v-else-if="securityVerifying" key="0005" class="verticle-center">
        <v-container class="horizontaly-center redirect-not-found">
          <v-avatar width="120" height="120" class="redirect-avatar">
            <v-img src="/images/logo/logo-04.png" contain width="120" class="pointer" @click="$router.push('/')"/>
          </v-avatar>
          <h1 class="redirect-not-found-title">{{ $t('securityVerifyingTitle') }}</h1>
          <p class="redirect-not-found-desc">{{ $t(securityStillInProgress ? 'securityVerifyingStillInProgress' : 'securityVerifyingDesc') }}</p>
          <v-btn rounded color="primary" class="text-none" elevation="0" :loading="securityContinueLoading" @click="continueAfterVerification">
            {{ $t('securityContinueButton') }}
          </v-btn>
        </v-container>
      </div>
      <div v-else-if="securityBlocked" key="0006" class="verticle-center">
        <v-container class="horizontaly-center redirect-not-found">
          <v-avatar width="120" height="120" class="redirect-avatar">
            <v-img src="/images/logo/logo-04.png" contain width="120" class="pointer" @click="$router.push('/')"/>
          </v-avatar>
          <h1 class="redirect-not-found-title">{{ $t('securityBlockedTitle') }}</h1>
          <p class="redirect-not-found-desc">{{ $t('securityBlockedDesc') }}</p>
          <a href="/">
            <v-btn rounded color="primary" class="text-none" elevation="0">
              {{ $t('securityBlockedCta') }}
            </v-btn>
          </a>
        </v-container>
      </div>
      <div v-else-if="notFound" key="0004" class="verticle-center">
        <v-container class="horizontaly-center redirect-not-found">
          <v-avatar width="120" height="120" class="redirect-avatar">
            <v-img src="/images/logo/logo-04.png" contain width="120" class="pointer" @click="$router.push('/')"/>
          </v-avatar>
          <h1 class="redirect-not-found-title">{{ $t('pageNotFoundTitle') }}</h1>
          <p class="redirect-not-found-desc">{{ $t('pageNotFoundDesc') }}</p>
          <a href="/">
            <v-btn rounded color="primary" class="text-none" elevation="0">
              {{ $t('backToHome') }}
            </v-btn>
          </a>
        </v-container>
      </div>
    </div>
    <v-bottom-sheet v-model="reportData.dialog" v-if="['xs' , 'sm'].includes($vuetify.breakpoint.name)">
      <LinkReport :data="reportData" :onlineAddress="address"/>
    </v-bottom-sheet>
    <v-navigation-drawer 
      v-else
      v-model="reportData.dialog"
      fixed
      width="450"
      height="100%"
      class="grey lighten-5"
      >
      <LinkReport :data="reportData" :onlineAddress="address"/>
    </v-navigation-drawer>
    <v-overlay :value="reportData.dialog" ></v-overlay>
  </div>
</template>


<script>
import { apiV1Click } from "../service/resources/api-v1-click"
import { apiV1OnlineAddresses } from "../service/resources/api-v1-online-addresses"
import { apiV1ContactAccessAddress } from "../service/resources/api-v1-contact-access-address"
import { apiV1SponsoredAds } from "../service/resources/api-v1-sponsored-ads"
import { apiV1Auth } from "../service/resources/api-v1-auth"
import BiographySmartphoneView from "./pages/fragments/BiographySmartphoneView.vue"
import InfoproductView from './pages/fragments/InfoproductView.vue'
import LinkReport from './pages/fragments/LinkReport.vue'
import SponsoredAdBanner from './pages/fragments/SponsoredAdBanner.vue'
import InterstitialBannerPreview from './pages/fragments/InterstitialBannerPreview.vue'
import authSession from "../service/auth-session";

  export default {
    name: 'Redirect',
    components: {
    BiographySmartphoneView,
    InfoproductView,
    LinkReport,
    SponsoredAdBanner,
    InterstitialBannerPreview
},
    data: () => ({
      loading: true,
      notFound: false,
      biography: null,
      config: null,
      interstitial: null,
      progress: 10,
      address: null,
      showIndex: false,
      infoproduct: null,
      isCancel: false,
      dialogReport: false,
      reportData: {dialog: false},
      securityStatus: null,
      securityVerifying: false,
      securityStillInProgress: false,
      securityBlocked: false,
      securityContinueLoading: false,
      continueGateDestination: null,
      continueGateSecondsLeft: 3,
      continueGateEnabled: false,
      continueGateImpressionId: null,
      currentUser: null
    }),
    computed: {
      // Free-plan (or ownerless) links show the sponsored-ad slot and, since this
      // change, must gate the redirect behind an explicit continue action instead of
      // auto-redirecting; PRO/BUSINESS links are unaffected. Single source of truth
      // for a check this file previously repeated inline three times.
      isFreePlanLink: function() {
        return !!this.address && (!this.address.user || !this.address.user.userHasSubscriptionPlans.filter(v => v.subscriptionPlan.name.includes('URL_SHORTNER')).filter(v => ['URL_SHORTNER_PRO', 'URL_SHORTNER_BUSINESS'].includes(v.subscriptionPlan.name))[0])
      },
      // True only when the visitor is logged in as the owner of this specific
      // free-plan link - drives the PRO upsell footer next to the sponsored ad
      // (a stranger or logged-out visitor never sees it).
      isOwnFreeLink: function() {
        return this.isFreePlanLink && !!this.currentUser && !!this.address.user && this.currentUser.id === this.address.user.id
      }
    },
    mounted: function() {
      this.loading = false
      apiV1OnlineAddresses.get(this.$route.params.code, {view : true}).then(result => {
        this.address = result.data
        if(result && result.data) {
          if(!this.$route.query.countClick)
            apiV1Click.post({
              onlineAddress: result.data,
              clickProperties: [
                {name: "platform" , value: window.navigator.platform, type : "STANDARD"},
                {name: "breakpoint-name" , value: this.$vuetify.breakpoint.name, type : "STANDARD"},
                {name: "share-on" , value: this.$route.query.s ? this.$route.query.s : 'undefined', type : "STANDARD"},
                ...this.buildOriginClickProperties(),
              ],
              userSessionId: this.$cookies.get('_migly')
              },
            )
          if(result.data.user)
            this.config = result.data.user.userHasSubscriptionPlans.filter(v => v.subscriptionPlan.name.includes('URL_SHORTNER')).filter(v => ['URL_SHORTNER_PRO', 'URL_SHORTNER_BUSINESS'].includes(v.subscriptionPlan.name))[0] ?  result.data.user.config : null
          this.interstitial = result.data.interstitial
          // Only worth asking "who is this visitor" when the link is free-plan
          // and has an owner at all - PRO links never show the upsell, and an
          // ownerless link has nothing to compare the visitor against.
          if(this.isFreePlanLink && result.data.user)
            this.loadCurrentUserForOwnerCheck()
          if(result.data.biography) {
            this.loading = false
            this.biography = result.data.biography
          } else if(result.data.infoproduct){
            this.loading = false
            this.infoproduct = result.data.infoproduct
            this.infoproduct.user = this.address.user
          } else {
            this.securityStatus = result.data.securityStatus
            if(this.securityStatus === 'INSEGURO') {
              this.loading = false
              this.securityBlocked = true
            } else if(this.securityStatus === 'VERIFICACAO_PENDENTE' || this.securityStatus === 'VERIFICACAO_INICIADA') {
              this.loading = false
              this.securityVerifying = true
            } else if(this.isFreePlanLink) {
              // Free-plan (or ownerless) link: no auto-redirect - the visitor must
              // activate "Continuar" after the countdown (see startContinueGate).
              this.startContinueGate(result.data.url)
            } else {
              // SEGURO (or no securityStatus at all, e.g. a Bio Page/Infoproduct destination
              // shell which is never gated), PRO/BUSINESS link - unchanged auto-redirect.
              this.scheduleNormalRedirect(result.data.url)
            }
          }

          // apiV1Configs.getByOnlineAddress(result.data.code).then(resultConfig => {
          //   //this.loading = true
          //     if(resultConfig.data && this.address.user && this.address.user.subscriptionPlan.id == 3) {
          //       this.config = resultConfig.data
          //     }
          //     setTimeout(() => {
          //       if(result.data.biography) {
          //         this.loading = false
          //         this.biography = result.data.biography
          //       } else if(result.data.infoproduct){
          //         this.loading = false
          //         this.infoproduct = result.data.infoproduct
          //         this.infoproduct.user = this.address.user
          //       } else {
          //         //this.showIndex = true
          //         // if(result.data.url.includes(`http`) || result.data.url.includes(`http`))
          //         //   window.location.href = result.data.url
          //         // else
          //         //   window.location.href = `http://${result.data.url}`
          //       }
          //     }, this.config ? this.config.loaderTime * 1000 : (!this.address.user || !this.address.user.userHasSubscriptionPlans.filter(v => v.subscriptionPlan.name.includes('URL_SHORTNER')).filter(v => ['URL_SHORTNER_PRO', 'URL_SHORTNER_BUSINESS'].includes(v.subscriptionPlan.name))[0]) ? 4000 : 2000);

          //     if(this.config)
          //       setInterval(() => {
          //         this.progress = this.progress + (100 / this.config.loaderTime)
          //       }, 1000);
          //     else
          //       setInterval(() => {
          //           this.progress = this.progress + (100 / 4)
          //         }, 1000);
          //   })
        }else {
          this.loading = false
          this.notFound = true
        }
      }).catch(() => {
        this.loading = false
        this.notFound = true
      })

      if(!this.$route.query.countClick)
        if(this.$route.params.contactCode) {
          apiV1ContactAccessAddress.save({
            smsShootingHasContact: {contact: {code: this.$route.params.contactCode}}, 
            smsShootingHasOnlineAddress: {onlineAddress: {code: this.$route.params.code}}}
            )
        }

    },
    methods: {
      isLoged: function() {
        return authSession.state.authenticated
      },
      // checkSession() (rather than reading authSession.state directly) because
      // main.js's app-level checkSession() call is still in flight when this
      // component mounts - this one is cached/idempotent and resolves to the
      // settled value. Silently no-ops on a logged-out visitor or a failed
      // lookup; isOwnFreeLink just stays false, which is the safe default.
      loadCurrentUserForOwnerCheck: function() {
        authSession.checkSession().then(authenticated => {
          if(!authenticated)
            return
          apiV1Auth.get().then(result => {
            this.currentUser = result.data && result.data.user
          }).catch(() => {})
        })
      },
      scheduleNormalRedirect: function(url) {
        this.loading = true
        setTimeout(() => {
          // this.showIndex = true
          if(!this.isCancel) {
            if(url.includes(`http`) || url.includes(`http`))
              window.location.href = url
            else
              window.location.href = `http://${url}`
          }
        }, this.interstitial ? this.interstitial.waitTime * 1000 : (!this.address.user || !this.address.user.userHasSubscriptionPlans.filter(v => v.subscriptionPlan.name.includes('URL_SHORTNER')).filter(v => ['URL_SHORTNER_PRO', 'URL_SHORTNER_BUSINESS'].includes(v.subscriptionPlan.name))[0]) ? 4000 : 2000);
        if(this.interstitial)
          setInterval(() => {
            if(!this.isCancel)
              this.progress = this.progress + (100 / this.interstitial.waitTime)
          }, 1000);
        else
          setInterval(() => {
            if(!this.isCancel)
              this.progress = this.progress + (100 / 4)
        }, 1000);
      },
      // Free-plan (or ownerless) links: no auto-redirect. Runs a 3-second countdown
      // (reusing the same `progress` state the existing destination-card linear bar and
      // top circular spinner already read) and then enables the "Continuar" action.
      // Independent of whether SponsoredAdBanner's own request succeeds - the countdown
      // and button always run on schedule, so a visitor is never stuck waiting on an ad
      // that failed to load (spec: "Continue gate degrades safely when no sponsored
      // product is available").
      startContinueGate: function(url) {
        this.loading = true
        this.continueGateDestination = url
        this.continueGateSecondsLeft = 3
        this.continueGateEnabled = false
        const countdownInterval = setInterval(() => {
          if(this.isCancel) {
            clearInterval(countdownInterval)
            return
          }
          this.progress = this.progress + (100 / 3)
          this.continueGateSecondsLeft = Math.max(0, this.continueGateSecondsLeft - 1)
          if(this.continueGateSecondsLeft <= 0) {
            clearInterval(countdownInterval)
            this.continueGateEnabled = true
          }
        }, 1000)
      },
      onSponsoredAdImpression: function(payload) {
        this.continueGateImpressionId = payload.impressionId
      },
      // The destination is always the one already resolved by the GET /online-addresses
      // response (continueGateDestination, set from startContinueGate's `url` argument) -
      // never a value read from the route/query string or otherwise supplied by the browser.
      activateContinueGate: function() {
        if(!this.continueGateEnabled || !this.continueGateDestination)
          return
        if(this.continueGateImpressionId)
          apiV1SponsoredAds.createContinue({
            impressionId: this.continueGateImpressionId,
            userSessionId: this.$cookies.get('_migly')
          })
        const url = this.continueGateDestination
        if(url.includes(`http`) || url.includes(`http`))
          window.location.href = url
        else
          window.location.href = `http://${url}`
      },
      // url-security-verification: re-checks the link's current status on the visitor's
      // explicit action, rather than assuming safety just because time passed on the
      // waiting screen (requirement "Explicit continue re-checks the current status").
      continueAfterVerification: function() {
        this.securityContinueLoading = true
        apiV1OnlineAddresses.get(this.$route.params.code, {view: true}).then(result => {
          this.securityContinueLoading = false
          this.address = result.data
          const status = result.data.securityStatus
          if(status === 'SEGURO') {
            this.securityVerifying = false
            if(this.isFreePlanLink)
              this.startContinueGate(result.data.url)
            else
              this.scheduleNormalRedirect(result.data.url)
          } else if(status === 'INSEGURO') {
            this.securityVerifying = false
            this.securityBlocked = true
          } else {
            this.securityStillInProgress = true
          }
        }).catch(() => {
          this.securityContinueLoading = false
        })
      },
      buildOriginClickProperties: function() {
        const reservedParams = ['s', 'countClick']
        let properties = []
        Object.keys(this.$route.query).forEach(key => {
          if(reservedParams.includes(key) || !this.$route.query[key])
            return
          let value = this.$route.query[key]
          properties.push({name: key, value: Array.isArray(value) ? value.join(',') : value, type: 'PARAM'})
        })
        if(document.referrer) {
          try {
            let referrerHost = new URL(document.referrer).hostname
            if(referrerHost && referrerHost !== window.location.hostname)
              properties.push({name: 'referrer', value: referrerHost, type: 'PARAM'})
          } catch(e) {
            // malformed referrer, skip it rather than block the click/redirect
          }
        }
        return properties
      }
    },
  }
</script>
<style scoped>
/* Reserves room at the bottom of the scrollable page for the fixed
   .redirect-owner-upsell footer bar, so it never overlaps the destination
   card/ad on a short viewport - see that bar's own comment for why it's
   fixed instead of living inside the ad's app-bar. */
.has-owner-upsell-footer {
  padding-bottom: 64px;
}

@media (max-width: 599px) {
  .has-owner-upsell-footer {
    padding-bottom: 104px;
  }
}

@media (min-width: 1264px) {
  .container {
    max-width: 600px !important;
  }
}

@media (min-width: 960px) {
  .container {
      max-width: 600px !important;
  }
}

/* The 600px cap above was sized for the old narrow phone-mockup bio layout.
   The new responsive Bio Page (bio-page-visual-redesign) wants its
   horizontal desktop composition to use up to 1000px, so this specific
   container opts back out via higher specificity — at the same 1024px
   breakpoint BiographySmartphoneView.vue and BioPrimaryLink.vue switch to
   the horizontal layout at. Below 1024px (including tablet widths between
   960-1024px) this stays at the 600px cap above, so the vertical/mobile
   bio composition doesn't stretch unreasonably wide before the card
   treatment kicks in. */
@media (min-width: 1024px) {
  .bio-page-container.container {
    max-width: 1048px !important;
    /* .bio-shell is now a bounded card (see BiographySmartphoneView.vue),
       so center it vertically in the viewport instead of pinning it near
       the top - single flex item, align-items handles the vertical
       centering while .bio-shell's own auto side-margins keep the
       horizontal centering it already had. */
    min-height: 100vh;
    display: flex;
    align-items: center;
  }
  .bio-page-container.container > .v-card {
    height: auto !important;
  }
}

/* The public infoproduct page's canvas color (#F7F5EF, same token as
   .infoproduct-page in InfoproductView.vue) has to live here too: the
   inner v-container caps out at 1048px on desktop, so its own background
   only ever paints that narrow column - this wrapper is the first
   full-bleed ancestor, so it's what actually colors the whole viewport. */
.infoproduct-page-wrap {
  background: #F7F5EF;
  min-height: 100vh;
}

/* Same narrow-container treatment as .bio-page-container above (same
   numeric values, independent class - see redesign-infoproduct-public-page
   design.md: reusing bio as a visual *reference*, not a shared class, so a
   future bio-only tweak can't silently reflow this page too). The generic
   .container{max-width:600px} rules further up would otherwise also cap
   this v-container at 600px from 960px up; this opts back out at the same
   1024px breakpoint bio does. InfoproductView is a plain block (no v-card
   wrapper), so align-items:center centers it when shorter than the
   viewport and has no effect - simply lets it flow from the top - once its
   own (usually much taller) content exceeds min-height:100vh. */
@media (min-width: 1024px) {
  .infoproduct-page-container.container {
    max-width: 1048px !important;
    min-height: 100vh;
    display: flex;
    align-items: center;
  }
  /* Bio's flex child opts in via v-card width="100%"; InfoproductView's own
     root <div> has no explicit width, so without this it would shrink-wrap
     to content instead of filling the flex row (align-items:center governs
     the cross/vertical axis only - main-axis sizing still defaults to
     shrink-to-fit on a flex item with no flex-grow/width set). */
  .infoproduct-page-container.container > div {
    width: 100%;
  }
}

/* styles.css */

.redirect-avatar-wrap {
  display: flex;
  justify-content: center;
  padding-top: 8px;
}

.redirect-avatar {
  box-shadow: 0 8px 24px rgba(25, 118, 210, 0.14);
}

.redirect-sitename {
  text-align: center;
  font-weight: 700;
  font-size: 1.25rem;
  letter-spacing: -0.01em;
  color: #26313e;
  margin-top: 16px;
}

.redirect-not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.5rem;
  max-width: 420px;
}

.redirect-not-found-title {
  font-weight: 700;
  font-size: 1.4rem;
  color: #26313e;
  margin-top: 1rem;
}

.redirect-not-found-desc {
  color: #5B6472;
  font-size: 0.95rem;
  margin-bottom: 0.5rem;
}

.redirect-progress-row {
  display: flex;
  justify-content: center;
  margin-top: 12px;
}

.redirect-body {
  padding-top: 20px;
}

.redirect-destination-card {
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #ffffff;
  padding: 20px;
}

.redirect-destination-label {
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #7E8EA6;
}

.redirect-destination-url {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace;
  font-size: 0.9rem;
  color: #26313e;
  margin-top: 6px;
  word-break: break-all;
}

.redirect-actions-row {
  display: flex;
  justify-content: center;
}

.redirect-cancel-trigger {
  display: inline-flex;
  flex-direction: column;
  gap: 6px;
  min-width: 220px;
  padding: 8px 4px;
  cursor: pointer;
  transition: transform 0.15s ease;
}

.redirect-cancel-trigger:active {
  transform: scale(0.98);
}

.redirect-cancel-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #26313e;
  text-align: center;
}

.redirect-report-btn,
.redirect-fallback-cta,
.redirect-continue-btn {
  transition: transform 0.15s ease;
}

.redirect-report-btn:active,
.redirect-fallback-cta:active,
.redirect-continue-btn:active {
  transform: scale(0.98);
}

.redirect-fallback-row {
  display: flex;
  justify-content: center;
  margin-top: 12px;
}

/* True page footer - fixed to the viewport bottom rather than living inside
   the sponsored-ad's own absolutely-positioned app-bar, so it reads as a
   distinct "by the way, here's your upgrade path" strip instead of part of
   the ad itself. .has-owner-upsell-footer (toggled on the scrollable
   .full-height root alongside this) reserves matching bottom padding so the
   bar never covers the destination card or the ad on a short viewport. */
.redirect-owner-upsell {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
  background: #ffffff;
  border-top: 1px solid rgba(2, 119, 189, 0.16);
  box-shadow: 0 -6px 20px rgba(16, 24, 39, 0.08);
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

.redirect-owner-upsell-inner {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.redirect-owner-upsell-icon {
  flex-shrink: 0;
}

.redirect-owner-upsell-text {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 0.78rem;
  line-height: 1.35;
  color: #26313e;
}

.redirect-owner-upsell-cta-link {
  flex-shrink: 0;
  text-decoration: none;
}

.redirect-owner-upsell-cta {
  transition: transform 0.15s ease;
}

.redirect-owner-upsell-cta:active {
  transform: scale(0.97);
}

/* Narrow phones: stack the message above the CTA instead of squeezing both
   into one row - matches the 320-360px widths real link clicks come from. */
@media (max-width: 599px) {
  .redirect-owner-upsell-inner {
    flex-wrap: wrap;
    justify-content: center;
    text-align: center;
  }

  .redirect-owner-upsell-cta-link {
    width: 100%;
  }

  .redirect-owner-upsell-cta-link .v-btn {
    width: 100%;
  }
}

@media (prefers-reduced-motion: no-preference) {
  .redirect-avatar-wrap,
  .redirect-sitename,
  .redirect-destination-card {
    animation: redirect-fade-up 0.5s ease both;
  }

  .redirect-sitename {
    animation-delay: 0.08s;
  }

  .redirect-destination-card {
    animation-delay: 0.16s;
  }
}

@keyframes redirect-fade-up {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

</style>